export default __webpack_public_path__ + "static/media/AX.eff68dcf.svg";